import {TimeDiff} from "_pages/service/queue/components/top-bar/TimeDiff";
import {Divider} from "@mui/material";
import {Button} from "_ui/Button";
import {useCurrentAttendanceSession, useEndAttendanceSession} from "_api/hooks/attendances";

export const EndSession = () => {
    const {attendanceSession} = useCurrentAttendanceSession();
    const {mutateAsync: onClick, isPending: loading} = useEndAttendanceSession();

    const {start: time} = attendanceSession;

    return (
        <>
            <TimeDiff {...{time}}/>
            <Divider orientation='vertical' flexItem/>
            <Button icon='fa fa-stop fs-2' variant='danger' {...{loading, onClick}}/>
        </>
    )
}
